import React, { useState, useEffect } from 'react';
import { useAppData } from './context/DataContext';
import { Link } from "react-router-dom";
import { Menu, Button, ConfigProvider } from 'antd';
import {
    UserOutlined,
    SearchOutlined,
    PlusOutlined,
    LogoutOutlined,
    LoginOutlined,
    AppstoreOutlined,
    SettingOutlined,
    TeamOutlined
} from '@ant-design/icons';
import Signin from './Signin';
import NavbarLogo from './NavbarLogo.svg';
import { ReactComponent as Avatar } from "./IconUmmahfy.svg";
import { Dropdown } from 'antd';
import { ReactComponent as NavbarLogoMobile } from "./Ummahfy Mobile Logo.svg";


function Navbar() {
    const {
        loggedInUser,
        loggedInEmail,
        userInfo,
        logout  // Get logout from context
    } = useAppData();

    const [isAdmin, setIsAdmin] = useState(userInfo ? userInfo.isAdmin : false);

    const [buttonSignin, setButtonSignin] = useState(false);
    const [showMenu, setShowMenu] = useState(window.innerWidth > 890);
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setShowMenu(window.innerWidth > 890);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const toggleDrawer = () => setIsDrawerOpen(!isDrawerOpen);
    const closeDrawer = () => setIsDrawerOpen(false);

    const getMobileMenuItems = () => {
        if (loggedInUser?.data) {
            return [
                isAdmin && {
                    key: 'admin',
                    icon: <SettingOutlined />,
                    label: <Link to="/adminPanel" onClick={closeDrawer}>Admin</Link>,
                },
                {
                    key: 'organizations',
                    icon: <TeamOutlined />,
                    label: <Link to="/organization" onClick={closeDrawer}>My Organizations</Link>,
                },
                {
                    key: 'events',
                    icon: <SearchOutlined />,
                    label: <Link to="/events" onClick={closeDrawer}>Find Events</Link>,
                },
                {
                    key: 'create-event',
                    icon: <PlusOutlined />,
                    label: <Link to="/newCreateEvent" onClick={closeDrawer}>Create Event</Link>,
                },
                {
                    key: 'profile',
                    icon: <UserOutlined />,
                    label: <Link to="/profile" onClick={closeDrawer}>Profile</Link>,
                },
                {
                    key: 'settings',
                    icon: <SettingOutlined />,
                    label: <Link to="/organizerSettings" onClick={closeDrawer}>Settings</Link>,
                },
                {
                    type: 'divider'
                },
                {
                    key: 'logout',
                    icon: <LogoutOutlined />,
                    danger: true,
                    label: 'Log Out',
                    onClick: logout,
                },
            ].filter(Boolean);
        } else {
            return [
                {
                    key: 'events',
                    icon: <SearchOutlined />,
                    label: <Link to="/events" onClick={closeDrawer}>Find Events</Link>,
                },
                {
                    key: 'signin',
                    icon: <LoginOutlined />,
                    label: 'Sign In',
                    onClick: () => { setButtonSignin(true); closeDrawer(); },
                },
            ];
        }
    };


    const getDesktopMenuItems = () => {
        return {
            items: [
                {
                    key: 'profile',
                    label: <Link to="/profile">Profile</Link>
                },
                {
                    key: 'myOrg',
                    label: <Link to="/organization" >My Organizations</Link>
                },
                {
                    key: 'settings',
                    label: <Link to="/organizerSettings"> Settings</Link>
                },
                {
                    type: 'divider'
                },
                {
                    key: 'logout',
                    label: <div
                        onClick={logout}
                    >
                        Log Out
                    </div>,
                    danger: true
                }
            ],
        };
    };

    return (
        <div className="navbar-container">
            <div className="navbar">
                <div className="item1">
                    <Link to="/" >
                        <NavbarLogoMobile
                            className="navbar-logo-mobile"
                            style={{
                                height: showMenu ? '40px' : '48px',
                                width: showMenu ? '80px' : '96px',
                                cursor: 'pointer',
                                transition: 'all 0.2s ease'
                            }}
                        />
                    </Link>
                </div>

                {showMenu ? (
                    <div className="item3">
                        <ul>
                            {isAdmin && (
                                <li>
                                    <Link to="/adminPanel">
                                        <button className="navb find-events-nav">Admin</button>
                                    </Link>
                                </li>
                            )}
                            <li>
                                <Link to="/events">
                                    <button className="navb find-events-nav">Find Events</button>
                                </Link>
                            </li>
                            {loggedInUser?.data ? (
                                <>
                                    <li>
                                        <Link to="/organization">
                                            <button className="navb find-events-nav">My Organizations</button>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/newCreateEvent">
                                            <button className="navb create-event-nav">Create Event</button>
                                        </Link>
                                    </li>
                                    <li>
                                        <ConfigProvider
                                            theme={{
                                                components: {
                                                    Dropdown: {
                                                        colorBgElevated: 'rgba(75, 75, 75, .95)',
                                                        colorText: '#fff',
                                                        controlItemBgHover: 'rgba(255, 255, 255, 0.075)',
                                                        boxShadowSecondary: 'rgba(0, 0, 0, 0.02) 0px 4px 12px',
                                                        /* here is your component tokens */
                                                    },
                                                },
                                            }}
                                        >
                                            <Dropdown
                                                menu={getDesktopMenuItems()}
                                                placement="bottomRight"
                                                trigger={['click']}
                                                arrow={{ pointAtCenter: true }}
                                            >
                                                <button className="navb nav-prof-photo">
                                                    {userInfo?.profilePicture ? (
                                                        <img
                                                            className="profile-photo"
                                                            src={userInfo.profilePicture}
                                                            alt="Profile"
                                                            style={{ width: '32px', height: '32px', borderRadius: '50%' }}
                                                        />
                                                    ) : (
                                                        <Avatar className="profile-photo" style={{ width: '32px', height: '32px' }} />
                                                    )}
                                                </button>
                                            </Dropdown>
                                        </ConfigProvider>
                                    </li>
                                </>
                            ) : (
                                <>
                                    <li>
                                        <button
                                            className="navb login"
                                            onClick={() => setButtonSignin(true)}
                                        >
                                            Sign In
                                        </button>
                                    </li>
                                </>
                            )}
                        </ul>
                    </div>
                ) : (
                    <div className="nav-icon-menu">
                        <input
                            type="checkbox"
                            id="drawer-toggle"
                            className="drawer-toggle"
                            checked={isDrawerOpen}
                            onChange={toggleDrawer}
                        />
                        {/* <label htmlFor="drawer-toggle" className="drawer-button">☰</label> */}
                        <ConfigProvider
                            theme={{
                                components: {
                                    Button: {
                                        defaultBg: 'rgba(75, 75, 75, .95)',
                                        colorText: '#fff',
                                        controlItemBgHover: 'rgba(255, 255, 255, 0.075)',
                                    },
                                },
                            }}
                        >
                        <Button
                            className="drawer-button"
                            style={{
                                background: 'linear-gradient(135deg, #2c489b 0%, #294594 6%, #183268 48%, #0d274d 81%, #0a2343 100%)',
                                color: 'white',
                                border: 'none',
                                padding: '0',
                                fontSize: '28px',
                                boxShadow: 'rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px',
                                borderRadius: '4px',
                                position: 'fixed',
                                top: '20px',
                                right: '16px',
                                zIndex: 998,
                                width: '48px',
                                height: '48px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                lineHeight: '1',
                                fontWeight: 'bold',
                                textShadow: '0 1px 1px rgba(0,0,0,0.3)'
                            }}
                            onClick={toggleDrawer}
                        >
                            ☰
                        </Button>
                        </ConfigProvider>

                        <div className={`drawer ${isDrawerOpen ? 'open' : ''}`}>
                            <nav>
                                <Menu
                                    mode="inline"
                                    theme="dark" 
                                    items={getMobileMenuItems()}
                                    className="mobile-menu-custom"
                                    style={{
                                        border: 'none',
                                        width: 'auto',
                                        background: 'transparent',
                                        fontSize: '16px',
                                        color: '#fff',
                                    }}
                                />
                            </nav>
                        </div>
                    </div>
                )}
            </div>

            <Signin
                trigger={buttonSignin}
                setTrigger={setButtonSignin}
            />
        </div>
    );
}

export default Navbar;